import gameproj from "./assets/gameproj.png";
import proj1 from "./assets/proj1.png";
import proj2 from "./assets/proj2.png";
import proj3 from "./assets/proj3.png";
import proj4 from "./assets/proj4.png";

{/*details to make this easy to add more to in the future*/}
export const projects = [
  {
    title: "3D game being developed for my thesis",
    image: gameproj,
    description:
      "3D Topdown. A game built for my thesis project. I use C# for Unity, Blender for 3D modelling, and shader work."
  },
  {
    title: "Poster Sample",
    image: proj1,
    description: "Previous sample graphic design project from a couple years ago for my digital design class."
  },
  {
    title: "Photo Edit Sample",
    image: proj2,
    description: "Previous sample graphic design project from a couple years ago for my digital design class."
  },
  {
    title: "Promotional Sample Piece",
    image: proj3,
    description: "Previous sample graphic design project from a couple years ago for my digital design class."
  },
    {
    title: "Springy's big leap",
    image: proj4,
    description: "2D platformer. One of the first few Unity games I worked on to get experience. Generic platformer with sprites made entby me and coded entirely by me."
  }
];

export const skills = [
              "Graphic Design",
              "Test-Driven Development",
              "Python",
              "C",
              "C#",
              "Lua",
              "Java",
              "HTML",
              "React",
              "TypeScript",
              "SQL",
              "PHP",
              "Docker",
              "Next.js",
              "Visual Studio",
              "Notepad++",
              "Github Version Control",
              "Microsoft Office",
              "Blender",
              "Krita",
              "Microsoft Excel",
              "React",
              "Next.js",
              "Scikit-learn",
              "Distributed Systems",
              "Data Modelling",
              "Feature Engineering",
              "Agile/Scrum",
              "Data Structures",
              "Digital Art",
              "3D Animation",
              "Computer Science tutoring",
              "Texturing",
              "UV Mapping",
              "Rendering",
              "Compositing",
              "Image editing",
              "Photoshop",
              "Game Modding",
              "Audio Engineering",
              "DaVinci Resolve",
]
